import React from 'react';
import { SearchCategory } from '../../../../types/enums';
import { Panel } from '../../../Panel';
import { AudienceSearch } from '../../../search/AudienceSearch';

export const RentersSearch = () => (
  <Panel backgroundColor="white" shadow>
    <AudienceSearch category={SearchCategory.Rental} />
  </Panel>
);
